<template>
  <div>
    <!-- special case: use "layer-3" style for Intracellular's -->
    <div 
      :class="[
        'test-container flex items-center justify-between mb-1 px-3 cursor-pointer',
        { 'filtered-test-highlight' : filteredTest && testNode.id === filteredTest.id },
        { 'not-allowed-select' : testNode.value[isNotAllowedSelectProp] },
        testNode.parent.id === 34 ?  classList[2] : classList[classIndex] 
      ]"
      @click.stop="handleClickTest(testNode.value)"
    >
      <DialogTestNameWithCheckbox 
        :test-node="testNode"
        :select-prop="selectProp"
        :is-not-allowed-select-prop="isNotAllowedSelectProp"
      />
    </div>
    <!-- special case: use grid layout for Intracellular or last level in each hierarchy  -->
    <div :class="{ 'grid grid-cols-4 gap-x-1': classIndex === 1 || testNode.id === 34 }">
      <DialogTestTreeNode
        v-for="descendant in testNode.descendants"
        :key="descendant.id"
        :test-node="descendant"
        :class-index="classIndex + 1"
        :order-test-support-obj="orderTestSupportObj"
        :filtered-test="filteredTest"
      />  
    </div>
  </div>
  
</template>

<script>
import DialogTestNameWithCheckbox from "./DialogTestNameWithCheckbox.vue";
import { addSelectedTest, getAllDescendants, removeSelectedTest } from "@/utils/va-order-test/testAndPanelSelection/testSelection.js";
export default {
  name: "DialogTestTreeNode",
  components: {
    DialogTestNameWithCheckbox
  },
  props: {
    testNode: {
      type: Object,
      default: () => {}
    },
    filteredTest: {
      type: Object,
      default: () => {}
    },
    classIndex: {
      type: Number,
      default: 0
    },
    selectProp: {
      type: String,
      default: "isSelect"
    },
    isNotAllowedSelectProp: {
      type: String,
      default: "isNotAllowedSelect"
    },    
    orderTestSupportObj: {
      type: Object,
      default: () => {}
    },
  },

  data() {
    return {
      // different design for each layer of tests in va or vw trees
      classList: ["layer-1", "layer-2", "layer-3"]
    }
  },

  methods: {
    // select or de-select test
    handleClickTest(test) {
      test[this.selectProp] 
        ? removeSelectedTest(test.id, this.selectProp, this.orderTestSupportObj)
        : addSelectedTest(test.id, this.selectProp, this.orderTestSupportObj);
    },
  }
}
</script>

<style scoped>
.test-container {
  background: #FFFFFF;
  font-weight: normal;
  font-size: 13px;
  line-height: 29px;
  letter-spacing: 0.15px;
  color: #000000;
  min-height: 25px;
}

.filtered-test-highlight {
  border: 1px solid #3498DB;
}

.not-allowed-select {
  pointer-events: none;
}

.layer-1 {
  height: 30px;
  background: #20A8C3;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 500;
  line-height: 29px; /* 181.25% */
  letter-spacing: 0.15px;
}

.layer-2 {
  background: #EBF7F9;
  color: #000000;
  font-size: 15px;
  font-weight: 500;
  line-height: 29px; /* 193.333% */
  letter-spacing: 0.15px;
}

.layer-3 {
  background: #F9F9F9;
  color: #000;
  font-weight: 400;
  line-height: 29px; /* 207.143% */
  letter-spacing: 0.15px;
}
</style>